import { Root } from './Root';
import { Content } from './Content';
import { Title } from './Title';
import { Description } from './Description';
import { Icon } from './Icon';

export default {
  Root,
  Content,
  Title,
  Description,
  Icon,
};
